<template>
    <div class="wl">
        <div class="ttBox"  @click="backward()">
            <img class="back" src="../assets/jxwx/arr_02.png" alt="">返回
        </div>
        <ul class="payType">
            <li>
                <div class="item1 ">客户名</div>
                <div class="item2">应收</div>
                <div class="item3">已收</div>
                <div class="item4">退扣返</div>
                <div class="item5">完成率</div>
            </li>
            <li v-for="item in data" :key="item.id">
                <div class="item1 ">{{item.SHOP_NAME}}</div>
                <div class="item2 ">{{item.AMOUNT_RECEIVEABLE}}</div>
                <div class="item3 ">{{item.AMOUNT_RECEIVED}}</div>
                <div class="item4 ">{{item.AMOUNT_REMOVE}}</div>
                <div class="item5 ">{{item.FINISH_RATE}}%</div>
            </li>
        </ul>
    </div>
</template>

<script>
import api from "@/axios/api";
import { mapGetters, mapActions } from "vuex";
export default {
    computed: {
        ...mapGetters(["token"])
    },
    watch: {
        // token: {
        //     immediate: true,
        //     handler: function(val) {
        //         if (val) {
        //             this.getmanagerreport(this.time1);
        //         }
        //     }
        // }
    },
    data() {
        return {
            data: [],
            time: this.$route.query.time
        };
    },
    filters: {},
    mounted() {
        this.getdeliverydetailbydate();
    },
    methods: {
        getdeliverydetailbydate() {
            let params = {
                SEARCH_TIME: this.time
            };
            api.getdeliverydetailbydate(params).then(res => {
                this.data = res[0].data;
            });
        },
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        }
    }
};
</script>

<style lang="less" scoped>
.payType {
    padding: 0.6vw 2vw;
    background-color: #fff;
    border-radius: 6px;
    li {
        display: flex;
        padding: 0;
        line-height: 1;
        color: #2c2c2c;
        text-align: center;
        box-sizing: border-box;
        // border-bottom: 1px solid #5fb8f8;
        div {
            padding: 2vw 0;
            font-size: 12px;
            box-sizing: border-box;
            color: #686464;
        }
        div:first-child {
            text-align: left;
        }
        .item1 {
            width: 28vw;
            border-right: 1px solid #92c619;
        }
        .item2 {
            width: 19vw;
            border-right: 1px solid #92c619;
        }
        .item3 {
            width: 19vw;
            border-right: 1px solid #92c619;
        }
        .item4 {
            width: 19vw;
            border-right: 1px solid #92c619;
        }
        .item5 {
            width: 15vw;
        }
    }
    li:first-child {
        color: #92c619;
        border-bottom: 1px solid #92c619;
        div {
            font-size: 14px;
            color: #92c619;
        }
        .item1 {
            width: 28vw;
            color: #92c619;
            border-right: none;
        }
        .item2 {
            width: 19vw;
            color: #92c619;
            border-right: none;
        }
        .item3 {
            width: 19vw;
            color: #92c619;
            border-right: none;
        }
        .item4 {
            width: 19vw;
            color: #92c619;
            border-right: none;
        }
        .item5 {
            width: 15vw;
            color: #92c619;
        }
    }
}
.ttBox {
    display: flex;
    align-items: center;
    margin-left: 4vw;
    padding: 2vw 0;
    line-height: 1;
    .back {
        width: 2vw;
        margin-right: 2.6vw;
    }
}
</style>





// WEBPACK FOOTER //
// src/yywl/deliveryDetail.vue